module.exports = __webpack_public_path__ + "img/deal-svgrepo-com.8686e902.svg";